<template>
	<div>
		<p>Over {{ countdown }} seconden ga je automatisch naar de frontpage...</p>
	</div>
</template>

<script>
export default {
	name: 'CountdownRedirect',
	props: {
		redirectUrl: {
			type: String,
			required: false,
			default: '/'
		},
		seconds: {
			type: Number,
			required: false,
			default: 10
		},
	},
	data() {
		return {
			countdown: this.seconds, // Initialize countdown with the passed seconds prop
		};
	},
	watch: {
		// Watcher to reset the countdown if the prop changes dynamically
		seconds(newVal) {
			this.countdown = newVal;
			this.startCountdown();
		}
	},
	created() {
		this.startCountdown();
	},
	methods: {
		startCountdown() {
			const interval = setInterval(() => {
				this.countdown -= 1;
				if (this.countdown <= 1) {
					clearInterval(interval);
					this.redirect();
				}
			}, 1000);
		},
		redirect() {
			window.location.href = this.redirectUrl;
		},
	},
};
</script>
